"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APMainLayout = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _APMainLayout = require("./APMainLayout.styles");
var _Breadcrumbs = require("../Breadcrumbs");
var _Typography = require("../Typography");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var APMainLayout = function APMainLayout(_ref) {
  var breadCrumbs = _ref.breadCrumbs,
    title = _ref.title,
    _ref$tabsOffset = _ref.tabsOffset,
    tabsOffset = _ref$tabsOffset === void 0 ? false : _ref$tabsOffset,
    rightAlignedCta = _ref.rightAlignedCta,
    pageTabs = _ref.pageTabs,
    children = _ref.children,
    height = _ref.height,
    stickyPositionTop = _ref.stickyPositionTop,
    sticky = _ref.sticky,
    titleStyle = _ref.titleStyle,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? false : _ref$responsive,
    _ref$breakpoint = _ref.breakpoint,
    breakpoint = _ref$breakpoint === void 0 ? '800px' : _ref$breakpoint;
  var tabsPresent = tabsOffset || false;
  var stickyPositionTopStyle = stickyPositionTop ? stickyPositionTop + 'px' : undefined;
  var classes = (0, _APMainLayout.useStyles)({
    height: height,
    stickyPositionTopStyle: stickyPositionTopStyle,
    titleStyle: titleStyle,
    responsive: responsive,
    breakpoint: breakpoint
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(classes.apHeader, height, sticky ? classes.stickyHeader : '')
  }, breadCrumbs && breadCrumbs.length > 0 && /*#__PURE__*/_react["default"].createElement(_Breadcrumbs.Breadcrumbs, {
    items: breadCrumbs
  }), /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
    variant: "h1",
    className: classes.apTitle
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.tabsAndCta
  }, pageTabs && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.apPageTabs
  }, pageTabs), rightAlignedCta && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.apRightAlignedCta
  }, rightAlignedCta))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(classes.apBody, tabsPresent && classes.withTabs, sticky && classes.stickyBody)
  }, children));
};
exports.APMainLayout = APMainLayout;